export default "__VITE_ASSET__Pw_ET0PM__";